import React from 'react';
import type { TeamMember } from '../data/team';
interface TeamMemberCardProps {
  member: TeamMember;
}

/** One card style for every team member: portrait (or monogram) with name and role. */
export function TeamMemberCard({
  member
}: TeamMemberCardProps) {
  return <figure className="flex h-full flex-col" data-id="element-281" data-mp="123vmujvv0egj">
      <div className="aspect-[4/5] w-full overflow-hidden rounded-3xl bg-primary-soft" data-id="element-282" data-mp="124oy9y5rjs50">
        {member.photo ? <img src={member.photo} alt={`Portret van ${member.name}`} loading="lazy" className="h-full w-full object-cover object-top" data-id="element-283" data-mp="172gs4xpyxobu" /> : <div className="flex h-full w-full items-center justify-center" aria-hidden="true" data-id="element-284" data-mp="1h1fqnnh0s3l4">
            <span className="flex h-24 w-24 items-center justify-center rounded-full bg-white font-display text-3xl font-semibold text-primary-dark" data-id="element-285" data-mp="1l2hobzvag7kz">
              {initials(member.name)}
            </span>
          </div>}
      </div>
      <figcaption className="mt-4" data-id="element-286" data-mp="3muw7t3dhdk3i">
        <p className="font-display text-lg font-semibold leading-snug text-ink" data-id="element-287" data-mp="3mvxqnu0qnavs">{member.name}</p>
        <p className="mt-0.5 text-sm text-muted" data-id="element-288" data-mp="3s9z8orcgaw44">{member.role}</p>
      </figcaption>
    </figure>;
}
function initials(name: string) {
  const parts = name.replace(/^Drs\.\s*/, '').split(/\s+/);
  const last = parts[parts.length - 1].replace(/-.*/, '');
  return `${parts[0][0]}${last[0]}`.toUpperCase();
}